/*
 * @Date: 2023-11-28 18:30:45
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-13 17:17:04
 * @FilePath: \hisea-ssr\src\components\LoadingIndicator\indicator.js
 */
import loading from '../../assets/images/loading.gif';
import { useStyle } from '../../classify';
import defaultClasses from './indicator.module.css';

const LoadingIndicator = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const className = props.global ? classes.global : classes.root;

  return (
    <div className={className}>
      <img
        src={loading.src}
        style={{
          width: '60px',
        }}
        alt=''
        className={classes.img}
      />
      <span className={classes.message}>{props.children}</span>
    </div>
  );
};

export default LoadingIndicator;
